<script lang="ts">
	type Props = {
		isFocused?: boolean
		isEditable?: boolean
		onDblClick?: (() => void) | null
		style?: string
		children?: import('svelte').Snippet | null
	}
	let {
		isFocused = false,
		isEditable = false,
		onDblClick = null,
		style = '',
		children = null
	}: Props = $props()
</script>

<div
	role="button"
	tabindex="0"
	class="data-column box"
	class:focused={isFocused && isEditable}
	{style}
	ondblclick={() => {
		if (!isEditable && onDblClick) {
			onDblClick()
		}
	}}
>
	{@render children?.()}
</div>

<style lang="postcss">
	.data-column.box {
		color: #000;
		padding: 10px;
		font-size: 150%;
		font-size: 12px;
		border-bottom: 1px solid #e4e7ed;
		display: flex;
		align-items: center;
	}
	.data-column {
		@apply min-w-[50px] break-words;
		white-space: normal; /* Allow text wrapping */
		word-wrap: break-word; /* Ensures long words wrap */
		overflow-wrap: anywhere; /* Break long words */
	}
	.data-column.focused {
		background-color: #007acc0d;
	}
</style>
